import { PageHeader, Row } from 'antd';
import React, { FC } from 'react';
import * as S from './CreateOrUpdateTask.styles';
import CreateOrUpdateTaskForm from '../../parts/CreateOrUpdateTaskForm/CreateOrUpdateTaskForm';
import { detailsViewTypeEnum } from '../../slice/types';
import TaskTabs from '../../parts/TaskTabs/TaskTabs';
import MapCard from '../../../Map/parts/MapCard/MapCard';
import { MapModeEnum } from '../../../Map/slice/types';
import { SelectedFieldsSummary } from '../../parts/SelectedFieldsSummary/SelectedFieldsSummary';
import CreateOrUpdateTaskResourcesCard from '../../parts/CreateOrUpdateTaskResourcesCard/CreateOrUpdateTaskResourcesCard';
import { getHeaderButtonsArray } from './CreateOrUpdateTask.helpers';
import RoutesWithotTaskFiltersCard from '../TaskListPage/parts/RoutesWithotTaskFiltersCard/RoutesWithotTaskFiltersCard';
import { useCreateOrUpdateTask } from './hooks/useCreateOrUpdateTask';
import TaskRoutesListCard from 'app/components/RouteListCards/TaskRoutesListCard/TaskRoutesListCard';

export const CREATE_TASK_FORM_ID = 'createTaskForm';

interface IProps {}

const CreateOrUpdateTask: FC<IProps> = () => {
  const {
    t,
    isTaskLoading,
    mobileOrTablet,
    selectedKey,
    taskRoutes,
    taskRecipeDescriptionAsNote,
    setTaskRecipeDescriptionAsNote,
    task,
    isEditPage,
    onSuccessRedirectTo,
    onBack,
    onDelete,
    onClickMenu,
    isConsultant,
    isCreateLoading,
    isTaskDeleteLoading,
    taskId,
    onSubmit,
  } = useCreateOrUpdateTask();

  if (isTaskLoading) {
    return null;
  }

  const responsivePadding = mobileOrTablet ? 6 : 12;

  const renderLeftPart = () => {
    return (
      <>
        {selectedKey === detailsViewTypeEnum.routes && (
          <div style={{ marginTop: 12 }}>
            <RoutesWithotTaskFiltersCard />

            <TaskRoutesListCard taskId={taskId as number} />
          </div>
        )}

        <S.FormCard
          bordered={false}
          $isVisible={selectedKey !== detailsViewTypeEnum.routes}
        >
          <CreateOrUpdateTaskForm
            onSubmit={onSubmit}
            taskRecipeDescriptionAsNote={taskRecipeDescriptionAsNote}
            setTaskRecipeDescriptionAsNote={setTaskRecipeDescriptionAsNote}
            initialTask={task}
            isEditPage={isEditPage}
            onSuccessRedirectTo={onSuccessRedirectTo}
          />
        </S.FormCard>
        <SelectedFieldsSummary fieldTasks={task?.fieldTasks} />
      </>
    );
  };

  const renderRightPart = () => {
    if (
      selectedKey === detailsViewTypeEnum.map ||
      selectedKey === detailsViewTypeEnum.routes
    ) {
      return (
        <MapCard
          mode={
            selectedKey === detailsViewTypeEnum.routes
              ? MapModeEnum.taskRoutes
              : MapModeEnum.view
          }
          showLayerMenu={selectedKey !== detailsViewTypeEnum.routes}
          showSelectFieldsByCulture={selectedKey !== detailsViewTypeEnum.routes}
        />
      );
    }

    if (selectedKey === detailsViewTypeEnum.resources) {
      return (
        <CreateOrUpdateTaskResourcesCard
          setTaskRecipeDescriptionAsNote={setTaskRecipeDescriptionAsNote}
        />
      );
    }
  };

  return (
    <>
      <PageHeader
        onBack={onBack}
        className="page-header"
        title={
          isEditPage
            ? task?.name
            : isConsultant
            ? t('Task.CreateRecommendation', 'Create recommendation')
            : t('Task.CreateTask.CreateTask', 'Create task')
        }
        extra={getHeaderButtonsArray({
          isEditPage,
          isCreateLoading,
          onDelete,
          isTaskDeleteLoading,
        })}
      />

      <Row
        wrap={mobileOrTablet}
        gutter={responsivePadding}
        style={{
          paddingLeft: responsivePadding,
          paddingTop: responsivePadding,
          width: '100%',
        }}
      >
        <S.LeftCol>
          <TaskTabs
            onClickMenu={onClickMenu}
            selectedKey={selectedKey}
            isRoutes={Boolean(taskRoutes?.length)}
          />
          {renderLeftPart()}
        </S.LeftCol>

        <S.MapAndResourcesCol>{renderRightPart()}</S.MapAndResourcesCol>
      </Row>
    </>
  );
};

export default CreateOrUpdateTask;
